import React, { useState } from "react";
import { colorPrimary } from "../../Styles/Colors";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Button from "@mui/material/Button";
import MicIcon from "@mui/icons-material/Mic";

const dsteps = [
  "page1 name",
  "page2 name",
  "page3 name",
  "page4 name",
  "page5 name",
];

export const Steper = ({
  steps = dsteps || [],
  activeStep = 0,
  style,
  onBack,
  onContinue,
}) => {
  const [complete, setComplete] = useState(0);
  // Custom connector for centered line
  const CustomConnector = (props) => {
    return (
      <StepConnector
        {...props}
        sx={{
          [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: "13px",
          },
          [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#ccc",
            borderTopWidth: 2,
            borderRadius: 1,
            minHeight: 0,
            margin: "8px 3px",
          },
          [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
            borderColor: colorPrimary,
          },
          [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
            borderColor: colorPrimary,
          },
        }}
      />
    );
  };

  return (
    <Box sx={{ width: "100%", ...style }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<CustomConnector />}
      >
        {steps?.map((label, idx) => (
          <Step key={label} completed={activeStep > idx}>
            <StepLabel
              sx={{
                "& .MuiStepLabel-label": {
                  color: activeStep >= idx ? colorPrimary : "#888",
                  fontWeight: activeStep === idx ? "bold" : "normal",
                  fontSize: "1rem",
                },
                "& .MuiStepIcon-root": {
                  fontSize: "2.5rem",
                  color: "#ccc",
                  borderColor: "#ccc",
                  borderWidth: 3,
                  borderStyle: "solid",
                  borderRadius: "50%",
                  padding: "3px",
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: colorPrimary,
                  borderColor: colorPrimary,
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: colorPrimary,
                  borderColor: colorPrimary,
                },
                "& .MuiStepIcon-text": {
                  fill: "#fff",
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
